/** Tiny toast bus for messages that are not store events (system notices, errors). */
export interface ToastMsg {
  kind: 'system' | 'error' | 'mastery' | 'achievement' | 'quest' | 'gap';
  title: string;
  body?: string;
  k?: string;
}

type Fn = (t: ToastMsg) => void;
const listeners = new Set<Fn>();

export function onToast(fn: Fn) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function toast(title: string, body = '', kind: ToastMsg['kind'] = 'system') {
  listeners.forEach((fn) => fn({ kind, title, body }));
}
